module.exports = __webpack_public_path__ + "img/jyb-assessment.946d30ba.png";